export const prefCetStr = 'tree.cetTest'
export const queryCetStr = 'cet_test'

export const queryTreeIdStr = 'treeId'
